import { Injectable } from '@angular/core';
import { FormBuilderService, FormData, FormField, FormProviderService, PreventDoubleSubmission } from '@fry/lib/forms';
import { UserFieldsStore } from '@fry/lib/user-fields';
import { User, UsersStore } from '@fry/lib/users';
import { Observable, throwError } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { defaultWidget } from '@fry/lib/forms/fields';
import { SecurityService } from '@fry/lib/security';

@Injectable()
export class UserEditDetailsForm {
  private formData: FormData;

  constructor(
    private provider: FormProviderService,
    private builder: FormBuilderService,
    private users: UsersStore,
    private userFields: UserFieldsStore,
    private security: SecurityService,
  ) {}

  getBasicFields(): Observable<FormField[]> {
    return this.userFields.all().pipe(
      map(data => {
        return data.map(item => {
          console.log(item.doc.fieldType);
          return {
            id: item.doc._id,
            title: item.doc.name,
            initial: '',
            validators: [],
            options: item.doc.categories || [],
            // options: categoriesToOptions(item.doc.categories || []),
            widget: { type: defaultWidget[item.doc.fieldType] }
          };
        });
      })
    );
  }

  getFields(roles: string[]): Observable<FormField[]> {
    return this.userFields.defaultFormVisibleBy(roles).pipe(
      switchMap(form => this.builder.buildForm(form, {}))
    );
  }

  init(user: User): Observable<FormData> {
    return this.security.getRolesFor(user.doc.user).pipe(
      switchMap(roles => {
        return this.getFields(roles);
      }),
      switchMap(fields => this.provider.getFormDataWith(fields, user.userFields)),
      tap(formData => this.formData = formData)
    );
  }

  @PreventDoubleSubmission()
  submit(user: User): Observable<User> {
    if (this.formData.invalid) {
      return throwError($localize `Please review the form`);
    }

    const value = this.formData.getValue();
    return this.users.updateDetails(user, value);
  }

  get pristine() {
    if (!this.formData) {
      return true;
    }
    return this.formData.pristine;
  }
}
